import { useTranslation } from 'react-i18next';

import UI from '../UI';
import useLocale from '../useLocale';

export interface DelayedInvoiceInfoProps {
  invoiceDate: string;
  email: string;
}

const DelayedInvoiceInfo = ({ invoiceDate, email }: DelayedInvoiceInfoProps) => {
  const { t } = useTranslation('common');
  const { formatDate, parseDate } = useLocale();

  return (
    <UI.Info icon={<UI.Icons.Pending />}>
      <UI.H5>
        {t('delayed_invoice_info.title')}
      </UI.H5>
      <UI.Paragraph sc={{ mb: 0 }}>
        {t('delayed_invoice_info.description', {
          date: formatDate(
            parseDate(invoiceDate, { timezone: 'UTC', format: 'internal_date' }),
            { format: 'display_date' },
          ),
          email,
        })}
      </UI.Paragraph>
    </UI.Info>
  );
};

export default DelayedInvoiceInfo;
